import { AccountInterface, UserInterface } from "../interfaces";

/**
 * Quién puede editar la ficha de un cliente.
 *
 * La regla ya existía, dispersa: `Clients.tsx:102-127` la implementa con
 * `isEnterprise` + `editable`, y `FiscalSustitutionModal.tsx:114-116` repite el
 * cálculo de `isEnterprise` por su cuenta. Esa dispersión es lo que dejó
 * `ShipmentOwner` y `DocumentDetailsModal` sin ninguna guarda: cada pantalla
 * nueva tenía que acordarse de reimplementarla, y no se acordaron.
 *
 * Módulo hoja (sólo importa de `../interfaces`) por la misma razón que
 * `billingValidations`: para que cualquier capa pueda usarlo sin arrastrar el
 * ciclo services → utils → services. No se exporta desde el barril.
 */

const READ_ONLY_ROLE = "Consulta Innovus";
const SUPERADMIN_ROLE = "Superadministrador";

/**
 * Cuenta corporativa: tiene contrato o cuentas autorizadas. Sus datos fiscales
 * los administra otra área, no la taquilla.
 */
export const isEnterpriseAccount = (account?: AccountInterface) =>
  !!account?.agreementID || (account?.listAuthorizingAccount?.length ?? 0) > 0;

/**
 * Regla única de edición de cuentas. Espeja `Clients.tsx:118-127` y le añade la
 * exclusión del rol de sólo lectura, que allí se aplicaba escondiendo el botón
 * (`Clients.tsx:438`) en vez de en la propia regla.
 *
 * Devuelve false sin cuenta: no se edita lo que no se ha cargado.
 */
export const canEditAccount = (
  user?: UserInterface | null,
  account?: AccountInterface
) => {
  if (!account) return false;
  if (!user || user.roleName === READ_ONLY_ROLE) return false;
  if (isEnterpriseAccount(account)) return user.roleName === SUPERADMIN_ROLE;
  return true;
};
